module.exports = __webpack_public_path__ + "static/media/screen-location-foreground.92162e93.svg";